import { render } from "./Emails.vue?vue&type=template&id=8516fa24"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"

import "./Emails.vue?vue&type=style&index=0&id=8516fa24&lang=scss"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__